/**
 * Created by chenzheyu on 2017/7/4.
 */

import XkbadgeMod from './src/badge.vue'

XkbadgeMod.install = function (Vue) {
  Vue.component(XkbadgeMod.name, XkbadgeMod)
}

export default XkbadgeMod



// WEBPACK FOOTER //
// ./src/components/module/badge/index.js